exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ContactSuggestSelector-contact-1OAaN{position:relative;overflow:hidden;padding-bottom:15px;text-transform:uppercase}.ContactSuggestSelector-contact-1OAaN i{display:block;float:left;margin-right:10px}.ContactSuggestSelector-contact-1OAaN .ContactSuggestSelector-container-3yCe5{overflow:hidden}.ContactSuggestSelector-contact-1OAaN .ContactSuggestSelector-container-3yCe5 p{margin:0}.ContactSuggestSelector-contact-1OAaN .ContactSuggestSelector-container-3yCe5 small{font-style:italic;font-weight:300;text-transform:none}.ContactSuggestSelector-contact-1OAaN a{position:absolute;display:block;bottom:0;right:0;text-transform:none;color:#00e5ce}.ContactSuggestSelector-data-3Jrnj{margin:0;padding:0;list-style-type:none}.ContactSuggestSelector-data-3Jrnj>li{margin:5px 0}.ContactSuggestSelector-data-3Jrnj>li label{font-weight:400;color:#546d79}.ContactSuggestSelector-data-3Jrnj>li input{text-align:center}", ""]);

// exports
exports.locals = {
	"contact": "ContactSuggestSelector-contact-1OAaN",
	"container": "ContactSuggestSelector-container-3yCe5",
	"data": "ContactSuggestSelector-data-3Jrnj"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/provider/components/ContactSuggestSelector.less
// module id = 1710
// module chunks = 0